/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { useSettings } from '../hooks/useSettings';
import { toWhatsAppUrl } from '../api/settings';
import { PLAY_STORE_URL, APP_STORE_URL } from './AppRedirect';
import '../styles/Home.css';

function Home() {
  const { settings } = useSettings();
  return (
    <>
      <Header home />

      {/* HERO */}
      <section className="hero">
        <div className="hero-left">
          <div className="hero-badge">
            <i className="ti ti-star" style={{fontSize:'14px'}}></i>
            Rated 4.9 by flower lovers across Gujarat
          </div>
          <h1 className="hero-h1">Fresh blooms,<br />delivered <em>to your door</em><br />in hours</h1>
          <p className="hero-p">Download the Sadguru Flower app — order farm-fresh bouquets, handcrafted varmalas, and premium gifts. Same-day delivery, live tracking, and seamless UPI checkout.</p>
          <div className="store-btns">
            <a className="store-btn" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
              <i className="ti ti-brand-apple"></i>
              <div className="store-btn-txt">
                <span className="s1">Download on the</span>
                <span className="s2">App Store</span>
              </div>
            </a>
            <a className="store-btn" href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
              <i className="ti ti-brand-google-play"></i>
              <div className="store-btn-txt">
                <span className="s1">Get it on</span>
                <span className="s2">Google Play</span>
              </div>
            </a>
          </div>
          <div className="hero-trust">
            <div className="trust-item"><i className="ti ti-truck-delivery"></i> Same-day delivery</div>
            <div className="trust-item"><i className="ti ti-shield-check"></i> Secure UPI checkout</div>
            <div className="trust-item"><i className="ti ti-leaf"></i> 100% farm-fresh</div>
          </div>
        </div>

        <div className="hero-phones">
          {/* Phone A: Home screen */}
          <div className="phone phone-a">
            <div className="ph-header">
              <div className="ph-header-txt">
                <div className="pht1">Sadguru Flower</div>
                <div className="pht2">Good morning!</div>
              </div>
              <i className="ti ti-shopping-cart"></i>
            </div>
            <div className="ph-body">
              <div className="ph-search">
                <i className="ti ti-search"></i>
                <span>Search flowers, varmalas…</span>
              </div>
              <div className="ph-promo">
                <div className="ph-promo-icon"><i className="ti ti-tag"></i></div>
                <div>
                  <div className="pp1">Spring sale — use code</div>
                  <div className="pp2">SPRING30 — Flat 30% off</div>
                </div>
              </div>
              <div className="ph-cats">
                <div className="ph-cat"><div className="pce">💐</div><div className="pcl">Bouquets</div></div>
                <div className="ph-cat"><div className="pce">👑</div><div className="pcl">Varmalas</div></div>
                <div className="ph-cat"><div className="pce">🌹</div><div className="pcl">Roses</div></div>
                <div className="ph-cat"><div className="pce">🎁</div><div className="pcl">Gifts</div></div>
              </div>
              <div className="ph-prod">
                <div className="ph-prod-img">🌸</div>
                <div>
                  <div className="pn">Spring Mix Bouquet</div>
                  <div className="ps">12 stems · Farm fresh</div>
                  <div className="pp">₹549</div>
                </div>
                <button className="ph-add-btn">Add</button>
              </div>
              <div className="ph-prod">
                <div className="ph-prod-img">👑</div>
                <div>
                  <div className="pn">Royal Rose Varmala</div>
                  <div className="ps">Jasmine &amp; Magenta</div>
                  <div className="pp">₹1,299</div>
                </div>
                <button className="ph-add-btn">Add</button>
              </div>
            </div>
          </div>

          {/* Phone B: Tracking screen */}
          <div className="phone phone-b">
            <div className="ph-b-header">
              <div className="bh1">Your order</div>
              <div className="bh2">Live tracking</div>
            </div>
            <div className="ph-b-body">
              <div className="track-steps">
                <div className="ts-dot done"><i className="ti ti-check"></i></div>
                <div className="ts-line done"></div>
                <div className="ts-dot done"><i className="ti ti-check"></i></div>
                <div className="ts-line done"></div>
                <div className="ts-dot active"><i className="ti ti-package"></i></div>
                <div className="ts-line gray"></div>
                <div className="ts-dot pending"><i className="ti ti-bike"></i></div>
              </div>
              <div className="track-labels">
                <div className="tl done">Confirmed</div>
                <div className="tl done">Packed</div>
                <div className="tl done">Shipped</div>
                <div className="tl">Delivery</div>
              </div>
              <div className="ph-b-card">
                <div className="bc1">Spring Mix Bouquet</div>
                <div className="bc2">Order #SF-2847 · Morbi</div>
                <div className="bc3"><i className="ti ti-clock"></i> Arriving by 6:00 PM today</div>
              </div>
              <div style={{fontSize:'10px', fontWeight:600, marginBottom:'7px', color:'var(--black)'}}>Payment method</div>
              <div className="pay-methods">
                <div className="pay-chip"><i className="ti ti-device-mobile"></i> UPI</div>
                <div className="pay-chip"><i className="ti ti-cash"></i> COD</div>
                <div className="pay-chip"><i className="ti ti-qrcode"></i> QR</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* STATS */}
      <div className="stats-strip">
        <div className="stat-cell"><div className="stat-num">10,000+</div><div className="stat-lbl">App downloads</div></div>
        <div className="stat-cell"><div className="stat-num">4.9 ★</div><div className="stat-lbl">Average rating</div></div>
        <div className="stat-cell"><div className="stat-num">Same day</div><div className="stat-lbl">Order by 4 PM</div></div>
        <div className="stat-cell"><div className="stat-num">Free delivery</div><div className="stat-lbl">On orders above ₹999</div></div>
      </div>

      {/* FEATURES */}
      <section className="section alt" id="features">
        <div className="sec-center">
          <div className="sec-eyebrow">Everything in the app</div>
          <h2 className="sec-h2">One app for every floral need</h2>
          <p className="sec-p">From a last-minute birthday bouquet to your wedding varmala — it's all a few taps away.</p>
        </div>
        <div className="features-grid">
          <div className="feat-card">
            <div className="feat-icon"><i className="ti ti-leaf"></i></div>
            <div className="feat-title">Farm-fresh guarantee</div>
            <div className="feat-desc">Flowers sourced daily from local premium farms. Every petal hand-inspected and packed in eco-friendly hydrating sheets.</div>
          </div>
          <div className="feat-card">
            <div className="feat-icon"><i className="ti ti-bolt"></i></div>
            <div className="feat-title">Same-day delivery</div>
            <div className="feat-desc">Order before 4 PM, receive by evening. We deliver 7 days a week — 8 AM to 9 PM, including all festivals and holidays.</div>
          </div>
          <div className="feat-card">
            <div className="feat-icon"><i className="ti ti-crown"></i></div>
            <div className="feat-title">Wedding varmalas</div>
            <div className="feat-desc">Hand-woven garlands with full specs — weight, size, shelf life (48 hrs), and pattern details before you order.</div>
          </div>
          <div className="feat-card">
            <div className="feat-icon"><i className="ti ti-map-pin"></i></div>
            <div className="feat-title">Live order tracking</div>
            <div className="feat-desc">Watch your order move through 4 stages in real time. Call your delivery partner directly from the app.</div>
          </div>
          <div className="feat-card">
            <div className="feat-icon"><i className="ti ti-shield-check"></i></div>
            <div className="feat-title">Secure &amp; fast checkout</div>
            <div className="feat-desc">OTP login — no passwords. Pay via Cash on Delivery, UPI QR scan, GPay, PhonePe, or Paytm.</div>
          </div>
          <div className="feat-card">
            <div className="feat-icon"><i className="ti ti-tag"></i></div>
            <div className="feat-title">Offers &amp; seasonal sales</div>
            <div className="feat-desc">Seasonal discounts and special collections in the app. Spring Sale is live — use SPRING30 for flat 30% off.</div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="section" id="how-it-works">
        <div className="sec-center">
          <div className="sec-eyebrow">How it works</div>
          <h2 className="sec-h2">Order in 3 simple steps</h2>
          <p className="sec-p">Downloading Sadguru Flower takes 30 seconds. Ordering takes under 2 minutes.</p>
        </div>
        <div className="steps-row">
          <div className="step-item">
            <div className="step-num">1</div>
            <div className="step-label">Browse &amp; pick</div>
            <div className="step-screen">
              <div style={{background:'var(--brand)', padding:'10px 10px 8px'}}>
                <div style={{fontSize:'10px', fontWeight:600, color:'white'}}>Sadguru Flower</div>
              </div>
              <div style={{padding:'10px'}}>
                <div style={{background:'var(--gray-100)', borderRadius:'8px', padding:'6px 10px', display:'flex', alignItems:'center', gap:'6px', marginBottom:'8px'}}>
                  <i className="ti ti-search" style={{fontSize:'12px', color:'var(--text-light)'}}></i>
                  <span style={{fontSize:'9px', color:'var(--text-light)'}}>Search flowers…</span>
                </div>
                <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'5px'}}>
                  <div style={{background:'#fce8e0', borderRadius:'8px', padding:'7px', textAlign:'center'}}>
                    <div style={{fontSize:'18px'}}>💐</div>
                    <div style={{fontSize:'8px', color:'var(--brand-text)', marginTop:'2px'}}>Bouquets</div>
                  </div>
                  <div style={{background:'#f0e8fa', borderRadius:'8px', padding:'7px', textAlign:'center'}}>
                    <div style={{fontSize:'18px'}}>👑</div>
                    <div style={{fontSize:'8px', color:'#534ab7', marginTop:'2px'}}>Varmalas</div>
                  </div>
                  <div style={{background:'#e8f8ee', borderRadius:'8px', padding:'7px', textAlign:'center'}}>
                    <div style={{fontSize:'18px'}}>🌹</div>
                    <div style={{fontSize:'8px', color:'#3b6d11', marginTop:'2px'}}>Roses</div>
                  </div>
                  <div style={{background:'#fef6e0', borderRadius:'8px', padding:'7px', textAlign:'center'}}>
                    <div style={{fontSize:'18px'}}>🎁</div>
                    <div style={{fontSize:'8px', color:'#854f0b', marginTop:'2px'}}>Gifts</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="step-sub">Pick from 40+ bouquets, varmalas, and gift combos</div>
          </div>

          <div className="step-item">
            <div className="step-num">2</div>
            <div className="step-label">Checkout &amp; pay</div>
            <div className="step-screen">
              <div style={{background:'var(--brand)', padding:'10px 10px 8px'}}>
                <div style={{fontSize:'10px', fontWeight:600, color:'white'}}>Checkout</div>
              </div>
              <div style={{padding:'10px'}}>
                <div style={{background:'var(--gray-100)', borderRadius:'8px', padding:'7px 9px', marginBottom:'8px'}}>
                  <div style={{fontSize:'8px', color:'var(--text-muted)'}}>Deliver to</div>
                  <div style={{fontSize:'9px', fontWeight:600, marginTop:'2px', color:'var(--black)'}}>Home — Morbi, Gujarat</div>
                </div>
                <div style={{fontSize:'8px', fontWeight:600, marginBottom:'5px', color:'var(--black)'}}>Pay with</div>
                <div style={{display:'flex', flexDirection:'column', gap:'4px'}}>
                  <div style={{background:'#fce8e0', borderRadius:'7px', padding:'5px 8px', fontSize:'8px', fontWeight:600, color:'var(--brand-text)', display:'flex', alignItems:'center', gap:'5px'}}>
                    <i className="ti ti-device-mobile" style={{fontSize:'12px'}}></i> UPI / GPay / PhonePe
                  </div>
                  <div style={{background:'var(--gray-100)', borderRadius:'7px', padding:'5px 8px', fontSize:'8px', color:'var(--text-muted)', display:'flex', alignItems:'center', gap:'5px'}}>
                    <i className="ti ti-cash" style={{fontSize:'12px'}}></i> Cash on delivery
                  </div>
                  <div style={{background:'var(--gray-100)', borderRadius:'7px', padding:'5px 8px', fontSize:'8px', color:'var(--text-muted)', display:'flex', alignItems:'center', gap:'5px'}}>
                    <i className="ti ti-qrcode" style={{fontSize:'12px'}}></i> QR code scan
                  </div>
                </div>
                <div style={{background:'var(--brand)', borderRadius:'8px', padding:'8px', textAlign:'center', marginTop:'10px'}}>
                  <span style={{fontSize:'10px', fontWeight:600, color:'white'}}>Place order</span>
                </div>
              </div>
            </div>
            <div className="step-sub">OTP login, saved addresses, multiple payment methods</div>
          </div>

          <div className="step-item">
            <div className="step-num">3</div>
            <div className="step-label">Track &amp; receive</div>
            <div className="step-screen">
              <div style={{background:'var(--brand)', padding:'10px 10px 8px'}}>
                <div style={{fontSize:'10px', fontWeight:600, color:'white'}}>Live tracking</div>
              </div>
              <div style={{padding:'10px'}}>
                <div style={{display:'flex', alignItems:'center', gap:'3px', marginBottom:'5px'}}>
                  <div style={{width:'20px', height:'20px', background:'var(--brand)', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <i className="ti ti-check" style={{color:'white', fontSize:'11px'}}></i>
                  </div>
                  <div style={{flex:1, height:'2px', background:'var(--brand)'}}></div>
                  <div style={{width:'20px', height:'20px', background:'var(--brand)', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <i className="ti ti-check" style={{color:'white', fontSize:'11px'}}></i>
                  </div>
                  <div style={{flex:1, height:'2px', background:'var(--brand)'}}></div>
                  <div style={{width:'20px', height:'20px', background:'var(--brand)', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <i className="ti ti-package" style={{color:'white', fontSize:'11px'}}></i>
                  </div>
                  <div style={{flex:1, height:'2px', background:'var(--gray-200)'}}></div>
                  <div style={{width:'20px', height:'20px', background:'var(--gray-100)', border:'1.5px solid var(--gray-200)', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <i className="ti ti-bike" style={{fontSize:'11px', color:'var(--text-light)'}}></i>
                  </div>
                </div>
                <div style={{background:'var(--brand-light)', borderRadius:'8px', padding:'7px 9px', marginTop:'10px', border:'1px solid var(--brand-border)'}}>
                  <div style={{fontSize:'9px', color:'var(--brand-text)', fontWeight:600}}>In transit</div>
                  <div style={{fontSize:'10px', color:'var(--black)', marginTop:'2px'}}>Arriving by 6:00 PM</div>
                </div>
                <div style={{background:'var(--gray-100)', borderRadius:'8px', padding:'7px 9px', marginTop:'7px', display:'flex', alignItems:'center', gap:'6px'}}>
                  <i className="ti ti-phone" style={{fontSize:'14px', color:'var(--brand)'}}></i>
                  <span style={{fontSize:'9px', color:'var(--text-muted)'}}>Call delivery partner</span>
                </div>
              </div>
            </div>
            <div className="step-sub">Live 4-stage tracking, call your delivery partner anytime</div>
          </div>
        </div>
      </section>

      {/* CITIES */}
      <section className="section alt">
        <div className="sec-center">
          <div className="sec-eyebrow">Delivery areas</div>
          <h2 className="sec-h2">Now delivering across Gujarat</h2>
          <p className="sec-p">We currently serve 4 cities with same-day delivery. More cities coming soon!</p>
        </div>
        <div className="cities-row">
          <div className="city-chip active"><i className="ti ti-map-pin"></i> Morbi</div>
          <div className="city-chip"><i className="ti ti-map-pin"></i> Rajkot</div>
          <div className="city-chip"><i className="ti ti-map-pin"></i> Jamnagar</div>
          <div className="city-chip"><i className="ti ti-map-pin"></i> Halvad</div>
          <div className="city-chip soon"><i className="ti ti-plus"></i> More cities coming soon</div>
        </div>
      </section>

      {/* REVIEWS */}
      <section className="section" id="reviews">
        <div className="sec-center">
          <div className="sec-eyebrow">Customer love</div>
          <h2 className="sec-h2">What our users say</h2>
          <p className="sec-p">Over 10,000 happy customers across Gujarat trust Sadguru Flower for every occasion.</p>
        </div>
        <div className="reviews-grid">
          <div className="review-card">
            <div className="rev-stars">★★★★★</div>
            <div className="rev-text">"Ordered a varmala for my wedding — absolutely stunning. The jasmine was so fresh and fragrant, exactly as described in the app!"</div>
            <div className="rev-user">
              <div className="rev-av">PJ</div>
              <div><div className="rev-name">Priya Joshi</div><div className="rev-city">Rajkot</div></div>
            </div>
          </div>
          <div className="review-card">
            <div className="rev-stars">★★★★★</div>
            <div className="rev-text">"Ordered at 2 PM and the bouquet was at my door by 6. The live tracking in the app is so smooth. My wife loved it!"</div>
            <div className="rev-user">
              <div className="rev-av">RK</div>
              <div><div className="rev-name">Ravi Kumar</div><div className="rev-city">Morbi</div></div>
            </div>
          </div>
          <div className="review-card">
            <div className="rev-stars">★★★★★</div>
            <div className="rev-text">"UPI checkout was instant and the discount code worked perfectly. Flowers stayed fresh for over a week. 10/10 would recommend!"</div>
            <div className="rev-user">
              <div className="rev-av">MA</div>
              <div><div className="rev-name">Meera Agarwal</div><div className="rev-city">Jamnagar</div></div>
            </div>
          </div>
        </div>
      </section>

      {/* DOWNLOAD CTA */}
      <section className="download-cta" id="download">
        <div className="dl-pill">Free to download</div>
        <h2 className="dl-h2">Get the Sadguru Flower app today</h2>
        <p className="dl-p">Send love, freshness, and celebration in just a few taps. Available on iOS and Android — completely free.</p>
        <div className="dl-btns">
          <a className="dl-store-btn" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
            <i className="ti ti-brand-apple"></i>
            <div><span className="ds1">Download on the</span><span className="ds2">App Store</span></div>
          </a>
          <a className="dl-store-btn" href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
            <i className="ti ti-brand-google-play"></i>
            <div><span className="ds1">Get it on</span><span className="ds2">Google Play</span></div>
          </a>
        </div>
        <div className="dl-note">Free delivery on orders above ₹999 &nbsp;·&nbsp; Delivers 8 AM – 9 PM &nbsp;·&nbsp; 7 days a week</div>
      </section>

      {/* FOOTER */}
      <footer className="footer" id="contact">
        <div className="footer-grid">
          <div>
            <div className="footer-brand-name">
              <img src="/logo.png" alt="Sadguru Flower" className="site-nav-logo" />
            </div>
            <div className="footer-brand-desc">Your premium floral delivery app — farm-fresh flowers, handcrafted bouquets, and exquisite wedding varmalas across Gujarat.</div>
            <div className="footer-contact">
              <a href={toWhatsAppUrl(settings.whatsappNumber)}><i className="ti ti-brand-whatsapp"></i> {settings.whatsappNumber}</a>
              <a href={`mailto:${settings.email}`}><i className="ti ti-mail"></i> {settings.email}</a>
            </div>
          </div>
          <div className="footer-col">
            <h4>App</h4>
            <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">Download for iOS</a>
            <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">Download for Android</a>
            <a href="#features">App features</a>
            <a href="#how-it-works">How it works</a>
          </div>
          <div className="footer-col">
            <h4>Company</h4>
            <Link to="/about">About us</Link>
            <a href="#">Delivery areas</a>
            <a href="#">Offers &amp; promotions</a>
            <Link to="/contact">Contact us</Link>
          </div>
          <div className="footer-col">
            <h4>Legal</h4>
            <Link to="/privacy">Privacy policy</Link>
            <a href="#">Terms of service</a>
            <a href="#">Refund policy</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2026 Sadguru Flower. All rights reserved.</p>
          <p>Made with care in Gujarat, India 🌸</p>
        </div>
      </footer>
    </>
  );
}

export default Home;
